import { render, staticRenderFns } from "./AddressCreate.vue?vue&type=template&id=76e0a1ee"
import script from "./AddressCreate.vue?vue&type=script&lang=js"
export * from "./AddressCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports